/**
 * "Status: Paid / Pending Payment" line shown under a "Paid to Vendor / Notary" select.
 *
 * The workflow document repeats the same rule on every payable step — "If the amount is not paid, it
 * should be shown as Pending Payment" (e.g. spec pg 133 for 4A(xxi), pg 138 for 4A(xxv)). The markup
 * was previously copy-pasted inline into each view (`StampPaperFromVendorView`,
 * `ExaminationReportView`, the Renewal / Legal Certificate / Assignment equivalents), and the two
 * Evidence steps were simply missing it. This is the shared version — the existing inline copies can
 * adopt it when those files are next touched.
 *
 * Renders nothing while the flag is still unset, so an untouched step shows no status at all.
 */
export default function PaymentStatusLine({ paid }: { paid: boolean | null }) {
  if (paid == null) return null;
  return (
    <p
      className="text-xs font-medium leading-5 text-[#222222] mt-0.5"
      style={{ fontFeatureSettings: "'ss01' on, 'cv01' on" }}
    >
      Status: {paid ? "Paid" : "Pending Payment"}
    </p>
  );
}
